(function () {
  'use strict';
  angular.module('vcdrug')
    .component('druginteraction', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
      <div>
        <span ng-repeat="int in vm.ints | orderBy: '-Grad'"
            class="btn" ng-class="int.Grad" ng-bind="int.Grad"
            uib-tooltip="{{int.Eff}}" popover-trigger="outsideClick"
                      uib-popover-template="vm.intpopovertpl" popover-title="{{int.Eff}}"
                      popover-placement="auto bottom"
            ></span>
      </div>
      <!-- Alternativen Pop-Over -->
      <script type="text/ng-template" id="intpopover.html">
          <div style="padding: 20px"><!-- template must be enclosed by single tag -->
          <h4 ng-show="int.Eff">Effekt</h4>
          <p ng-show="int.Eff">{{int.Eff}}</p>
          <h4 ng-show="int.Mechanismus">Mechanismus</h4>
          <p ng-show="int.Mechanismus">{{int.Mechanismus}}</p>
          <h4>Medikamente</h4>
          <ul>
            <li ng-show="int.drugname1">
              {{int.drugname1}} ({{int.Atc1}}<span ng-show="int.Name1"> , {{int.Name1}}</span>)
            </li>
            <li ng-show="int.drugname2">
              {{int.drugname2}} ({{int.Atc2}}<span ng-show="int.Name2"> , {{int.Name2}}</span>)
            </li>
            <li ng-repeat="n in int.drugnames track by $index">{{n}} ({{int.Atc1}})</li>
          </ul>
          <h4>Klinik: {{int.Kli}}</h4>
          <p>{{int.Klinik}}</p>
          <h4 ng-show="int.Pmids">Publikationen</h4>
          <ul ng-show="int.Pmids">
            <li ng-repeat="pub in int.Pmids.split(',')">
              <a href="https://www.ncbi.nlm.nih.gov/pubmed/?term={{pub}}" target="_blank">PubMed {{pub}}</a>
            </li>
          </ul>
          </div>
      </script>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'DrugInteraction', 'Drug', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, DrugInteraction, Drug, Rlog, vertxEventBusService, $http) {
          let vm = this;
          vm.intpopovertpl = 'intpopover.html';

          vm.$onInit = function () {

            DrugInteraction.$search({patientid: vm.patientid}).$then(function (int) {
              $log.debug(int);
              vm.interactions = int;
            });

            // we need to lookup patdrugs to be able to trigger interaction refresh on patdrugs update
            Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
              vm.patdrugs = drugs[0];
              let drugsByAtc = {};
              let atcs = [];
              vm.ints = [];
              vm.intsnix = [];
              for (let i = 0; i < vm.patdrugs.drugs.length; i++) {
                if (vm.patdrugs.drugs[i] && vm.patdrugs.drugs[i].active) {
                  if (angular.isArray(vm.patdrugs.drugs[i].atcarray)) {
                    for (let j = 0; j < vm.patdrugs.drugs[i].atcarray.length; j++) {
                      if (drugsByAtc.hasOwnProperty(vm.patdrugs.drugs[i].atcarray[j])) {
                        drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]].push(vm.patdrugs.drugs[i]);
                      } else {
                        atcs.push(vm.patdrugs.drugs[i].atcarray[j]);
                        drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]] = [];
                        drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]].push(vm.patdrugs.drugs[i]);
                      }
                    }
                  } else {
                    let tmpz = {
                      Grad: 'U',
                      Kli: 'Dieses Medikament hat keinen ATC Wirkstoffcode. Es k&ouml;nnen keine Aussagen zu Interaktionen getroffen werden.',
                      drugname1: vm.patdrugs.drugs[i].name
                    };
                    vm.ints.push(tmpz);
                  }
                }
              }
              // $log.debug('*********** drugsByAtc array: ', drugsByAtc, atcs);


              Object.keys(drugsByAtc).forEach(function (atc) {
                if (drugsByAtc[atc].length > 1) {
                  let tmpz = {
                    Grad: 'Y',
                    Kli: 'Mögliche Überdosierung.',
                    Klinik: 'Es wurden mehrere Medikamente mit dem selben Wirkstoff verordnet. Möglicherweise liegt eine Überdosierung vor.',
                    Atc1: atc
                  };

                  let drugnames = [];
                  for (let i = 0; i < drugsByAtc[atc].length; i++) {
                    drugnames.push(drugsByAtc[atc][i].name);
                  }
                  tmpz.drugnames = drugnames;
                  vm.ints.push(tmpz);
                }
              });
              // $log.debug('*********** ints array: ', vm.ints);

              for (let i = 0; i < atcs.length; i++) {
                for (let j = i + 1; j < atcs.length; j++) {


                  $http.get('/routes/druginteractions/' + atcs[i] + '/' + atcs[j]).then(function (int) {
                    // $log.debug('******* interaction i, j, int: ', atcs[i], atcs[j], int.data, int.data[0]);
                    if (int.data.length > 0) {
                      let tmp = int.data[0];
                      $log.debug('}} dru by atc: ', drugsByAtc[atcs[i]]);
                      tmp.drugname1 = drugsByAtc[atcs[i]][0].name;
                      tmp.drugname2 = drugsByAtc[atcs[j]][0].name;
                      vm.ints.push(tmp);
                    } else {
                      let tmp = {
                        Grad: 'Z',
                        Kli: 'Es wurden keine Interaktionsdaten gefunden.',
                        Klinik: 'Es wurden keine Interaktionsdaten gefunden. Es können keine Aussagen zu Interaktionen getroffen werden.'
                      };
                      tmp.Atc1 = atcs[i];
                      tmp.Atc2 = atcs[j];
                      tmp.drugname1 = drugsByAtc[atcs[i]][0].name;
                      tmp.drugname2 = drugsByAtc[atcs[j]][0].name;
                      vm.intsnix.push(tmp);
                    }
                  }); // $http.get

                }
              } // loop i
              // $log.debug('*********** ints array: ', vm.ints);

            });

          };


          const patdrugsUpdateHandler = function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.patdrugs)) {
              if (vm.patdrugs._id === messages[0]) {
                vm.interactions.$refresh().$then(function () {
                  $log.debug('refreshed interactions for: ', vm.patientid);
                }, function (error) {
                  $log.debug('refreshing interactions failed: ', error, vm.patientid);
                });
              }
            }
          };

          // refresh interactions on patdrugschange
          vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
          };


        }] // controller
    }); // component

// klammerfriedhof
}());
